const gatsbyImage = require('gatsby-plugin-image');
const slugify = require('slugify');
const pathUtils = require('./path');
const config = require('../../config/site');

exports.getSiteCatalogs = (siteSettings, allCatalogs) => {
  const result = {
    hasPrimary: false,
    primaryId: '',
    primaryOriginalId: '',
    primaryTitle: '',
    primaryNode: null,
    hasSecondary: false,
    secondaryId: '',
    secondaryOriginalId: '',
    secondaryTitle: '',
    secondaryNode: null,
  };

  // site settings: get definition of primary & secondary catalog
  const hasPrimaryId = siteSettings && siteSettings.catalog && siteSettings.catalog.id;
  result.primaryId = hasPrimaryId ? siteSettings.catalog.id : '';
  result.primaryOriginalId = hasPrimaryId ? siteSettings.catalog.originalId : '';
  result.primaryTitle = hasPrimaryId ? siteSettings.catalog.title : '';

  const hasSecondaryId = siteSettings && siteSettings.catalogAlt && siteSettings.catalogAlt.id;
  result.secondaryId = hasSecondaryId ? siteSettings.catalogAlt.id : '';
  result.secondaryOriginalId = hasSecondaryId ? siteSettings.catalogAlt.originalId : '';
  result.secondaryTitle = hasSecondaryId ? siteSettings.catalogAlt.title : '';

  // catalog collection: get datasets of both catalogs
  if (allCatalogs && allCatalogs.length > 0) {
    allCatalogs.forEach(({ node }) => {
      const pageCode = node && node.id ? node.id : '';
      if (hasPrimaryId && pageCode === result.primaryId) {
        result.primaryNode = node;
        result.hasPrimary = true;
      }
      if (hasPrimaryId && hasSecondaryId && pageCode === result.secondaryId) {
        result.secondaryNode = node;
        result.hasSecondary = true;
      }
    });
  }
  return result;
};

exports.getOriginalIdFromCatalog = (catalogType, catalogSettings) => {
  let result = '';

  if (catalogType === config.catalog.catalog.primary) {
    if (catalogSettings.hasPrimary) {
      result = catalogSettings.primaryOriginalId;
    }
  }
  if (catalogType === config.catalog.catalog.secondary) {
    if (catalogSettings.hasSecondary) {
      result = catalogSettings.secondaryOriginalId;
    }
  }
  return result;
};

exports.getSearchPathFromSegment = (
  segmentType,
  segmentKey,
  catalogType,
  siteSetting,
  allCatalogs
) => {
  const catalogSettings = this.getSiteCatalogs(siteSetting, allCatalogs);
  const catQueryKey = config.catalog.catalog.querykey;
  const catId = this.getOriginalIdFromCatalog(catalogType, catalogSettings);
  const pageBasePath = config.catalog.search.slug;

  let pagePath = pathUtils.createPagePathOfMultiCatalog(
    catalogType,
    pageBasePath,
    '',
    catalogSettings
  );
  if (typeof catId === 'string' && typeof segmentKey === 'string') {
    pagePath = `${pagePath}?${catQueryKey}=${slugify(catId)}&${segmentType}=${slugify(segmentKey)}`;
  }

  return pagePath;
};

exports.getLabelFromPageType = (pagetype) => {
  let result = pagetype;
  if (pagetype === 'home') result = 'Home';
  else if (pagetype === config.catalog.about.code) result = 'Über Uns';
  else if (pagetype === config.catalog.info.code) result = 'Information';
  else if (pagetype === config.catalog.infos.code) result = 'Information';
  else if (pagetype === config.catalog.privacy.code) result = 'Datenschutz';
  else if (pagetype === config.catalog.imprint.code) result = 'Impressum';
  else if (pagetype === config.catalog.booking.code) result = 'Buchungsanfrage';
  else if (pagetype === config.catalog.bookingOk.code) result = 'Reservierung gesendet';
  else if (pagetype === config.catalog.contact.code) result = 'Kontaktanfrage';
  else if (pagetype === config.catalog.contactOk.code) result = 'Kontaktanfrage gesendet';
  else if (pagetype === config.catalog.newsletter.code) result = 'Newsletteranfrage';
  else if (pagetype === config.catalog.newsletterOk.code) result = 'Newsletteranfrage gesendet';
  else if (pagetype === config.catalog.newsletterConfirm.code) result = 'Newsletter Bestätigung';
  else if (pagetype === config.catalog.newsletterConfirmOk.code)
    result = 'Newsletter Bestätigung durchgeführt';

  return result;
};

exports.getLabelFromProductType = (producttype) => {
  let result = producttype;
  if (producttype === 'travel') result = 'Reise';
  else if (producttype === 'show') result = 'Veranstaltung';
  else if (producttype === 'camp') result = 'Camp';
  else if (producttype === 'foodsubsidy') result = 'Essenszuschuss';
  else if (producttype === 'contribution') result = 'Finanzielle Unterstützung';
  else if (producttype === 'benefit') result = 'Einkaufsvorteil';
  else if (producttype === 'product') result = 'Produkt';
  else if (producttype === 'voucher') result = 'Gutschein';

  return result;
};

exports.getLabelsFromNodes = (nodes) => {
  let result = [];
  if (nodes && Array.isArray(nodes) && nodes.length > 0) {
    nodes.forEach((node) => {
      result.push(node.title);
    });
  }
  return result;
};

exports.getGalleryImages = (imageNodes) => {
  let result = [];
  if (imageNodes && Array.isArray(imageNodes) && imageNodes.length > 0) {
    imageNodes.forEach((node) => {
      const imageSrc = gatsbyImage.getSrc(node.gatsbyImageData);
      const thumbSrc = node.fixed.src;
      result.push({ original: imageSrc, thumbnail: thumbSrc });
    });
  }
  return result;
};
